import { Global, css } from "@emotion/react";
import React, { useRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import close from "../../../assets/images/close.svg";
import { useTheme } from "@chakra-ui/react";
import { useField } from "formik";
import { isValid } from "date-fns";
import en from "date-fns/locale/en-US";
import fr from "date-fns/locale/fr";
import nl from "date-fns/locale/nl";
import de from "date-fns/locale/de";
import { withTranslation } from "react-i18next";

require("react-datepicker/dist/react-datepicker.css");
registerLocale("en", en);
registerLocale("fr", fr);
registerLocale("nl", nl);
registerLocale("de", de);

const DatePickerField = (props) => {
  const theme = useTheme();
  const { i18n } = props;
  // eslint-disable-next-line
  const [field, meta, helpers] = useField(props);
  let datePickerRef = useRef(null);
  const { value } = field;
  const DatepickerInput = ({ ...props }) => <input type="text" {...props} readOnly />;

  return (
    <>
      <Global
        styles={css`
          body {
            .react-datepicker__header {
              background: ${theme.colors.primary};
              border-bottom: 1px solid ${theme.colors.primary};
              border-radius: 0;
              padding: 0;
            }
            .react-datepicker__input-container {
              height: 100%;
              border-radius: 10px;
              input {
                font-family: ${theme.fonts.body};
                color: ${theme.colors.primary};
                border-radius: 10px;
                text-align: center;
                width: 100%;
                height: 100%;
              }
            }
            .react-datepicker-wrapper {
              width: 100%;
              height: 100%;
            }
            .react-datepicker {
              border: 1px solid ${theme.colors.primary};
              border-radius: 5px;
            }
            .react-datepicker__navigation--next {
              border-left-color: white;
            }
            .react-datepicker__navigation--previous {
              border-right-color: white;
            }
            .react-datepicker__day {
              margin: 3px;
              font-size: 12px;
              width: 18px;
              height: 18px;
              line-height: 18px;
              color: ${theme.colors.primary};
              user-select: none;
            }
            .react-datepicker__day--disabled {
              color: rgb(0 0 0 / 6%) !important;
            }
            .react-datepicker__day-name {
              font-size: 12px;
              color: ${theme.colors.white};
              height: fit-content;
              width: 18px;
              line-height: 0.5em;
              margin: 0.5px 3px 0.5px;
            }
            .react-datepicker__day--keyboard-selected {
              background-color: ${theme.colors.primary};
              color: ${theme.colors.white};
            }
            .react-datepicker__day--selected {
              color: ${theme.colors.white};
              background-color: ${theme.colors.primary};
            }
            .react-datepicker__day--selected:hover {
              color: ${theme.colors.primary};
            }
            .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
              border-bottom-color: ${theme.colors.primary};
              margin-top: -5px;
            }
            .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
              border-bottom-color: ${theme.colors.primary};
              top: -1px;
            }
            .react-datepicker__day:hover,
            .react-datepicker__month-text:hover {
              background-color: ${theme.colors.primary};
              color: ${theme.colors.white};
              border-radius: 5px;
            }
            .react-datepicker-wrapper,
            .react-datepicker__input-container {
              width: 100%;
            }
            .react-datepicker__day--outside-month {
              visibility: hidden;
            }
            .react-datepicker__day--disabled {
              color: ${theme.colors.primary};
            }
            .react-datepicker__day--disabled:hover {
              background-color: transparent;
            }
            .react-datepicker__current-month {
              color: ${theme.colors.white};
              font-size: 1em;
              padding-top: 0.5em;
            }
            .react-datepicker__close-icon::after {
              cursor: pointer;
              background-color: transparent;
              font-size: 12px;
              content: " ";
              height: 24px;
              width: 24px;
              background-image: url(${close});
              background-repeat: no-repeat;
            }
            .react-datepicker__close-icon {
              top: 3px;
            }
          }
        `}
      />
      <DatePicker
        ref={datePickerRef}
        onChange={(date) => {
          if (date) {
            const dateInstance = new Date(date);
            if (isValid(dateInstance)) {
              helpers.setValue(dateInstance);
            }
          } else {
            helpers.setValue("");
          }
        }}
        locale={i18n.language}
        minDate={props.minDate}
        maxDate={props.maxDate}
        closeOnScroll={true}
        selected={(value && new Date(value)) || null}
        dateFormat={"dd-MM-yyyy"}
        calendarStartDay={1}
        popperModifiers={{
          preventOverflow: {
            enabled: true,
          },
        }}
        customInput={<DatepickerInput />}
      />
    </>
  );
};
export default withTranslation()(DatePickerField);
